// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(min-width: 1024px)";
var _3 = "(max-width: 1024px)";
var _4 = "screen and (max-width: 600px)";
var _5 = "addButton-36q9N";
var _6 = "addButton__icon--wjqX";
var _7 = "form__wrapper-d079P";
var _8 = "form-31Y-y";
var _9 = "fields-V8oKD";
var _a = "form__input-26049";
var _b = "buttons-2vgrY";
var _c = "submitButton-1vP9e";
var _d = "cancelButton-Q_Bai";
var _e = "form__title-37pQi";
var _f = "passengerIcon-kc57r";
var _10 = "conditionButton-1p0kB";
var _11 = "notification-29Euq";
var _12 = "notification_context-2SAIu";
var _13 = "notification__text-2ngXk";
var _14 = "infoIcon-35p3c";
var _15 = "infoIcon__error-V7hi9";
var _16 = "infoModalTitle-32LHv";
var _17 = "wrapper-MFuZT";
export { _1 as "__esModule", _2 as "desktop_only", _3 as "tablet", _4 as "mobile", _5 as "addButton", _6 as "addButton__icon", _7 as "form__wrapper", _8 as "form", _9 as "fields", _a as "form__input", _b as "buttons", _c as "submitButton", _d as "cancelButton", _e as "form__title", _f as "passengerIcon", _10 as "conditionButton", _11 as "notification", _12 as "notification_context", _13 as "notification__text", _14 as "infoIcon", _15 as "infoIcon__error", _16 as "infoModalTitle", _17 as "wrapper" }
export default { "__esModule": _1, "desktop_only": _2, "tablet": _3, "mobile": _4, "addButton": _5, "addButton__icon": _6, "form__wrapper": _7, "form": _8, "fields": _9, "form__input": _a, "buttons": _b, "submitButton": _c, "cancelButton": _d, "form__title": _e, "passengerIcon": _f, "conditionButton": _10, "notification": _11, "notification_context": _12, "notification__text": _13, "infoIcon": _14, "infoIcon__error": _15, "infoModalTitle": _16, "wrapper": _17 }
